"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NavMobile;
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _react2 = require("../hooks/react");

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

var _ExpansionPanel = _interopRequireDefault(require("../ExpansionPanel/ExpansionPanel"));

var _ExpansionPanelSummary = _interopRequireDefault(require("../ExpansionPanel/ExpansionPanelSummary"));

var _ExpansionPanelDetails = _interopRequireDefault(require("../ExpansionPanel/ExpansionPanelDetails"));

var _TrackingLink = _interopRequireDefault(require("../TrackingLink"));

var _Footer = _interopRequireDefault(require("../Footer"));

var _theme = require("../utils/theme");

var _Header = require("./Header");

var _core = require("@material-ui/core");

var MenuIcon = function MenuIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 10h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4zm24 4H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4zm0 8H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z"
  }));
};

MenuIcon.defaultProps = {
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};

var EarnUpLogo = function EarnUpLogo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Group 17"), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    id: "a",
    d: "M.08.044h9.94V15.74H.08z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "c",
    d: "M0 .071h9.68v11.483H0z"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.612 0l-.085.163c-.052.109-.142.263-.27.464-.261.392-.65.971-1.235 1.635a27.037 27.037 0 0 1-2.233 2.29c-.92.829-2.01 1.71-3.256 2.6-1.249.885-2.665 1.757-4.206 2.607-1.546.843-3.232 1.628-5.008 2.368l-1.357.524-.688.26-.701.24c-.469.159-.94.32-1.415.48l-1.447.43-.729.215-.737.193-1.483.378c-.997.228-2.001.445-3.007.648-2.02.366-4.048.684-6.057.883-1.005.096-2 .214-2.987.255l-1.47.087-.728.04-.723.015-1.426.029c-.47.006-.937.028-1.398.012l-2.703-.053c-.877-.033-1.73-.089-2.553-.137l-1.214-.077-1.166-.11-2.183-.222c-.692-.081-1.346-.178-1.96-.264-.615-.09-1.19-.168-1.72-.253-.53-.08-1.014-.182-1.453-.258-.876-.157-1.561-.304-2.029-.393l-.715-.15.731-.002c.476.005 1.176-.003 2.06.017.885.028 1.962.01 3.192.012.616-.004 1.269.015 1.958.004l2.167-.034 1.154-.01 1.197-.044c.811-.033 1.65-.041 2.51-.084l2.644-.14c.9-.056 1.818-.134 2.752-.201 1.865-.153 3.786-.352 5.729-.604a103.37 103.37 0 0 0 5.852-.931c.973-.189 1.943-.39 2.906-.602.954-.245 1.922-.43 2.855-.702 1.89-.478 3.707-1.068 5.465-1.65 1.74-.624 3.411-1.263 4.959-1.954a57.285 57.285 0 0 0 4.28-2.118 48.905 48.905 0 0 0 3.452-2.104c.993-.68 1.838-1.31 2.508-1.863A19.217 19.217 0 0 0 61.133.534c.158-.168.285-.298.36-.393l.12-.141M48.715 23.407v7.327c0 1.32-.837 2.178-2.198 2.178H45.51c-1.36 0-2.198-.859-2.198-2.178v-7.327h-1.78v7.117c0 2.325.88 3.957 3.728 3.957h1.507c2.848 0 3.727-1.632 3.727-3.957v-7.117h-1.78z",
    fill: "#FFF"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(52.861 23.026)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.05 10.104c-2.374 0-3.308-2.03-3.308-4.232 0-2.094.894-4.21 3.207-4.21 2.232 0 3.246 2.03 3.246 4.124 0 2.18-.791 4.318-3.144 4.318M5.19.044c-1.44 0-2.778.54-3.347 1.77h-.04V.302H.08v15.436h1.724V9.974h.04c.771 1.317 2.313 1.749 3.39 1.749 3.204 0 4.786-2.656 4.786-5.807 0-3.152-1.602-5.872-4.828-5.872",
    fill: "#FFF",
    mask: "url(#b)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0 23.026)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.326 5.056c.21-1.978 1.408-3.87 3.575-3.87 2.146 0 3.386 1.872 3.449 3.87H1.326zM4.901.07C1.45.071 0 2.953 0 5.812c0 3.093 1.451 5.742 4.9 5.742 2.735 0 4.165-1.43 4.733-3.89H8.308c-.421 1.64-1.473 2.775-3.407 2.775-2.545 0-3.555-2.334-3.575-4.269h8.349C9.78 3.12 8.392.071 4.9.071z",
    fill: "#FFF",
    mask: "url(#d)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.544 25.956h-.042v-2.544h-1.22v10.853h1.325V28.48c0-2.251 1.641-4.018 4.037-3.891v-1.325c-1.954-.085-3.427.947-4.1 2.691M35.293 23.097c-1.536 0-2.988.883-3.471 2.186h-.042v-1.871h-1.325v10.853h1.325v-6.33c.042-2.125 1.303-3.723 3.408-3.723 2.145 0 2.754 1.408 2.754 3.28v6.773h1.325V27.28c0-2.586-.925-4.184-3.974-4.184M19.077 30.12h-.001v.042c-.003.189.001.87.001 1.075 0 1.786-1.283 2.228-2.84 2.228h-.946c-1.241 0-2.418-.82-2.418-2.145a2.062 2.062 0 0 1 .068-.53c.004-.016.008-.032.014-.048a1.542 1.542 0 0 1 .21-.436l.03-.041a1.723 1.723 0 0 1 .393-.384l.003-.002a2.46 2.46 0 0 1 .378-.227l.065-.03c.046-.022.092-.044.14-.064l.112-.043a.152.152 0 0 1 .027-.01c.04-.016.082-.03.124-.045a3.057 3.057 0 0 0 .077-.025 1.62 1.62 0 0 1 .126-.04c.054-.015.11-.03.166-.047.064-.017.127-.034.193-.049.062-.015.124-.03.187-.043.194-.043.396-.08.601-.115.202-.034.406-.065.613-.095l.242-.034.345-.05.07-.01c.114-.015.226-.032.337-.05.105-.015.21-.031.314-.049l.213-.035c.356-.064.946-.169 1.114-.485h.042v1.788zm-.001-6.394a4.915 4.915 0 0 0-.144-.088 4.97 4.97 0 0 0-.148-.08 4.976 4.976 0 0 0-.31-.136 2.06 2.06 0 0 0-.132-.047 1.032 1.032 0 0 0-.086-.03 3.743 3.743 0 0 0-.244-.07c-.045-.011-.09-.023-.135-.031a5.06 5.06 0 0 0-.586-.1 6.954 6.954 0 0 0-.475-.037 7.803 7.803 0 0 0-1.57.08c-.031.005-.063.01-.094.018a1.687 1.687 0 0 0-.117.021c-.052.01-.102.02-.15.034a3.185 3.185 0 0 0-.168.04l-.037.01a8.104 8.104 0 0 0-.367.118 3.888 3.888 0 0 0-.515.23c-.047.026-.095.052-.14.08l-.064.038a3.163 3.163 0 0 0-.524.403l-.031.03c-.03.029-.058.057-.084.086a2.51 2.51 0 0 0-.267.32 2.207 2.207 0 0 0-.097.14c-.018.03-.038.06-.057.093a2.776 2.776 0 0 0-.128.234l-.015.033a2.268 2.268 0 0 0-.066.147c-.004.01-.008.018-.01.027-.019.04-.034.082-.049.124a1.13 1.13 0 0 0-.04.116c-.006.015-.012.029-.014.043a1.57 1.57 0 0 0-.036.118c-.013.044-.025.088-.036.133l-.009.037a2.945 2.945 0 0 0-.045.216c-.01.052-.018.103-.026.157-.004.017-.005.033-.008.05a5.9 5.9 0 0 0-.042.452h1.325c.003-.101.009-.199.019-.292.003-.028.005-.056.011-.084a.849.849 0 0 1 .013-.09v-.008c.007-.048.016-.096.027-.142.008-.04.018-.08.028-.118l.008-.03c.01-.04.022-.08.036-.12 0-.004.002-.007.003-.011a3.03 3.03 0 0 1 .097-.244 2.037 2.037 0 0 1 .414-.607c.007-.008.013-.015.02-.02a1.42 1.42 0 0 1 .083-.078.985.985 0 0 1 .094-.08c.032-.025.065-.051.1-.074.032-.025.067-.046.101-.07a2.483 2.483 0 0 1 .5-.24c.043-.017.087-.033.132-.046l.109-.033a3.65 3.65 0 0 1 .447-.09c.022-.005.045-.007.067-.01.142-.019.29-.029.441-.033.05-.003.1-.003.153-.003 1.556 0 2.84.441 2.84 2.228a1.968 1.968 0 0 1-.125.745.82.82 0 0 1-.088.161c-.012.019-.025.036-.038.053a.834.834 0 0 1-.206.189 1.229 1.229 0 0 1-.255.13 1.53 1.53 0 0 1-.113.038c-.027.009-.055.017-.084.024l-.067.018-.019.004a1.784 1.784 0 0 1-.147.03 2.943 2.943 0 0 1-.267.043c-.094.013-.193.026-.295.038l-.587.067-.382.043c-.065.006-.13.015-.195.022a32.87 32.87 0 0 0-.864.114l-.09.013a12.232 12.232 0 0 0-1.072.213 9.71 9.71 0 0 0-.428.122 14.012 14.012 0 0 0-.204.07l-.026.01a4.773 4.773 0 0 0-.554.252 3.168 3.168 0 0 0-.588.414 2.564 2.564 0 0 0-.266.285 2.098 2.098 0 0 0-.177.255 2.49 2.49 0 0 0-.22.476 3.13 3.13 0 0 0-.157.762c-.001.013-.003.026-.003.04a1.79 1.79 0 0 0-.005.091 1.14 1.14 0 0 0-.005.1c-.001.047-.003.094-.003.142 0 2.188 1.64 3.176 3.638 3.176h1.22c.94 0 1.917-.141 2.67-.629.785-.503 1.326-1.382 1.326-2.862v-4.501c0-1.48-.541-2.359-1.326-2.862z",
    fill: "#FFF"
  })));
};

EarnUpLogo.defaultProps = {
  width: "64",
  height: "40",
  viewBox: "0 0 64 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Window = typeof window !== 'undefined' ? window : {}; // Content & Routes of Mobile Nav Menu

var styles = function styles(theme) {
  return {
    header: {
      zIndex: theme.zIndex.appBar,
      width: '80vw',
      position: 'fixed',
      top: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      backgroundColor: function backgroundColor(props) {
        return (0, _theme.getBgColorByHeaderType)(theme, props.type);
      },
      boxShadow: function boxShadow(props) {
        return props.type === _Header.MARKETING ? 'none' : '0 2px 4px 0 rgb(0,0,0,0.22)';
      }
    },
    logoContainer: {
      width: function width(props) {
        return props.mobileLogoWidth || theme.spacing(9.125);
      },
      height: theme.spacing(6.875),
      display: 'flex',
      alignItems: 'center'
    },
    logo: {
      height: '100%',
      width: function width(props) {
        return props.mobileLogoWidth || theme.spacing(8);
      }
    },
    itemsList: {
      marginTop: theme.spacing(9),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      '& .MuiIconButton-label': {
        color: theme.palette.primary.main
      },
      '& .MuiExpansionPanel-root': {
        boxShadow: 'none'
      }
    },
    subItemsList: {
      marginLeft: 0,
      borderLeft: 'solid 3px',
      borderColor: theme.palette.primary.main,
      paddingLeft: theme.spacing(1),
      paddingTop: 0,
      paddingBottom: 0
    },
    list: {
      width: '80vw'
    },
    menuIconContainer: {
      paddingRight: theme.spacing(1)
    },
    menuIcon: {
      "float": 'right',
      fill: function fill(props) {
        return (0, _theme.getFillByHeaderType)(theme, props.type);
      }
    },
    navLinkText: {
      color: function color(props) {
        return props.contrastBg ? theme.palette.primary.main : theme.typography.body1.color;
      },
      fontSize: theme.typography.body1.fontSize,
      fontWeight: '500'
    },
    emailUsLinks: {
      textAlign: 'left'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
var defaultOverrideFooter = undefined;

function NavMobile(_ref) {
  var type = _ref.type,
      _ref$Logo = _ref.Logo,
      Logo = _ref$Logo === void 0 ? EarnUpLogo : _ref$Logo,
      contrastBg = _ref.contrastBg,
      items = _ref.items,
      _ref$Link = _ref.Link,
      Link = _ref$Link === void 0 ? _TrackingLink["default"] : _ref$Link,
      SiteLinks = _ref.SiteLinks,
      SocialLinks = _ref.SocialLinks,
      EmailUs = _ref.EmailUs,
      _ref$overrideFooter = _ref.overrideFooter,
      overrideFooter = _ref$overrideFooter === void 0 ? defaultOverrideFooter : _ref$overrideFooter,
      mobileLogoWidth = _ref.mobileLogoWidth,
      isPartner = _ref.isPartner;
  var classes = useStyles({
    contrastBg: contrastBg,
    type: type,
    mobileLogoWidth: mobileLogoWidth
  });

  var _useState = (0, _react2.useState)({
    left: false
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var toggleDrawer = function toggleDrawer(side, open) {
    return function (event) {
      Window.analytics && Window.analytics.track('click', {
        type: 'drawer',
        action: open ? 'open' : 'close'
      });
      setState((0, _extends3["default"])({}, state, (0, _defineProperty2["default"])({}, side, open)));
    };
  };

  var sideList = function sideList(side) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.list,
      role: "presentation"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.header
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.logoContainer
    }, /*#__PURE__*/_react["default"].createElement(Logo, {
      className: classes.logo
    }))), /*#__PURE__*/_react["default"].createElement(_core.List, {
      className: classes.itemsList,
      items: items
    }, items.map(function (item, i) {
      if (item.subMenu !== undefined) {
        return /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
          Component: "div",
          key: "mobile-nav-submenu-".concat(i)
        }, /*#__PURE__*/_react["default"].createElement(_ExpansionPanel["default"], null, /*#__PURE__*/_react["default"].createElement(_ExpansionPanelSummary["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.navLinkText
        }, item.buttonName)), /*#__PURE__*/_react["default"].createElement(_ExpansionPanelDetails["default"], null, /*#__PURE__*/_react["default"].createElement(_core.List, {
          className: classes.subItemsList,
          items: items.subMenu
        }, item.subMenu.map(function (subMenuItem) {
          return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
            button: true,
            key: subMenuItem.textName,
            component: Link,
            to: subMenuItem.route,
            dataQa: "mobile-sub-nav-".concat(subMenuItem.textName)
          }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
            classes: {
              primary: classes.navLinkText
            },
            primary: subMenuItem.textName,
            onClick: toggleDrawer(side, false)
          }));
        })))));
      } else {
        return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
          button: true,
          key: item.buttonName,
          component: Link,
          to: item.route,
          dataQa: "mobile-nav-".concat(item.name)
        }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
          classes: {
            primary: classes.navLinkText
          },
          primary: item.buttonName,
          onClick: toggleDrawer(side, false)
        }));
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.Divider, null), /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
      items: items,
      logo: Logo,
      SiteLinks: SiteLinks,
      SocialLinks: SocialLinks,
      EmailUs: EmailUs,
      inMobileNav: true,
      overrideFooter: overrideFooter,
      isPartner: isPartner
    }));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.menuIconContainer
  }, /*#__PURE__*/_react["default"].createElement(MenuIcon, {
    className: classes.menuIcon,
    onClick: toggleDrawer('left', true)
  }), /*#__PURE__*/_react["default"].createElement(_core.SwipeableDrawer, {
    open: state.left,
    onClose: toggleDrawer('left', false),
    onOpen: toggleDrawer('left', true)
  }, sideList('left')));
}